import { render, staticRenderFns } from "./list_view.vue?vue&type=template&id=24f10a22"
import script from "./list_view.vue?vue&type=script&lang=js"
export * from "./list_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports